import React from 'react';
import {useSelector} from 'react-redux';
import {useReducerAsync} from 'use-reducer-async';
import {useParams} from 'react-router-dom';

import getAsyncActionHandlers from './store/asyncActionHandlers';
import reducer from './store/reducer';

import SubcontractorDetailsContainer from './SubcontractorDetailsContainer';

const interventionsPageSize = 10;
const usersPageSize = 25;
const remindersPageSize = 10;

const initialState = {
  dossierCountry: null,
  subcontractor: {
    details: null,
    loading: true,
    error: false
  },
  documents: {
    list: [],
    loading: true,
    error: false
  },
  archives: {
    list: [],
    loading: true,
    error: false
  },
  interventions: {
    list: [],
    loading: true,
    error: false,
    totalCount: 0,
    pageSize: interventionsPageSize
  },
  users: {
    list: [],
    loading: true,
    error: false,
    totalCount: 0,
    pageSize: usersPageSize
  },
  reminders: {
    list: [],
    loading: true,
    error: false,
    totalCount: 0,
    pageSize: remindersPageSize
  }
};
const store = React.createContext(initialState);
export const useSubcontractorDetailsStore = () => React.useContext(store);

function SubcontractorDetailsStore() {
  const organisation = useSelector(globalState => globalState.organisation);
  const params = {
    subcontractorId: Number(useParams().subcontractorId),
    organisationId: organisation.organisationId,
    organisationCountry: organisation.country,
    interventionsPageSize,
    usersPageSize,
    remindersPageSize
  };

  const {Provider} = store;

  const [state, dispatch] = useReducerAsync(
    reducer,
    initialState,
    getAsyncActionHandlers(params)
  );

  return (
    <Provider value={{state, dispatch}}>
      <SubcontractorDetailsContainer/>
    </Provider>
  );
}

export default SubcontractorDetailsStore;
